var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSwitcher === 'true')?_c('select',{staticClass:"py-1 px-2 bg-transparent",domProps:{"value":_vm.$i18n.locale},on:{"change":_vm.changeLocale}},_vm._l((['el', 'en']),function(lang,i){return _c('option',{key:`Lang${i}`,domProps:{"value":lang}},[_vm._v(" "+_vm._s(lang)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }